import { CountryCode, Option, PostCheckoutSurveyOptionStatus } from '../pages/types';

export const COUNTRY_OPTIONS: Option[] = [
  { value: CountryCode.US, label: `🇺🇸 ${CountryCode.US}` },
  { value: CountryCode.CA, label: `🇨🇦 ${CountryCode.CA}` },
];

export const STATUS_OPTIONS: Option[] = [
  { value: PostCheckoutSurveyOptionStatus.ACTIVE, label: PostCheckoutSurveyOptionStatus.ACTIVE },
  { value: PostCheckoutSurveyOptionStatus.HIDDEN, label: PostCheckoutSurveyOptionStatus.HIDDEN },
];

const labelToSlug = (label: string): string =>
  label
    .toLowerCase()
    .replace(/\([^)]*\)/g, '')
    .replace(/[^a-z\s]/g, '')
    .trim()
    .replace(/\s+/g, '_');

export const isValidPostCheckoutSurveyOptionLabel = (label: string): boolean =>
  Boolean(labelToSlug(label));

export const generatePostCheckoutSurveyOptionValue = (
  label: string,
  country: CountryCode
): string => {
  const suffix = country === CountryCode.CA ? '_can' : '_us';
  const slug = labelToSlug(label);
  if (!slug) {
    throw new Error('Label must contain at least one alphanumeric character');
  }
  return `${slug}${suffix}`;
};
